<template>
  <div>
    <div class="chart-container">
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <span>{{$t('Alerts')}}</span>
        </div>
        <div class="main-header-right">
          <button @click="print"><span>{{$t('print')}}</span></button>
          <button class="set" @click="open"><span>{{$t('set')}}</span></button>
          <p>{{$t('period')}}:<span class="time">{{timeRangeDisplay}}</span></p>
        </div>
      </div>
      <hr class="small-hr spe-hr">

      <!--表格-->
      <div class="no-data" v-show="!haveData">{{$t('No data')}}</div>
      <div class="patient-table" v-show="haveData">
        <table id="patientList" v-cloak>
          <tr class="header">
            <td width="30%">{{$t('time')}}<div class="order"></div></td>
            <td width="20%">{{$t('type')}}</td>
            <td>{{$t('alert')}}</td>
          </tr>
          <tr v-for="(item,index) in alerts" :class="(index%2===0) ? '':'even'" :id='index'>
            <td class="event-time">{{item[0]}}</td>
            <td class="event-type">{{item[3]}}</td>
            <td class="event-detail">{{item[1]}}</td>
          </tr>
        </table>
      </div>

    </div>

    <!--时间选择对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}:</span>
          <select id="duration"  @change = "procTimeRangeSelect" v-model="timeRangeSelect">
            <option value=1>{{$t('7 days')}}</option>
            <option value=2>{{$t('14 days')}}</option>
            <option value=3>{{$t('30 days')}}</option>
            <option value=4>{{$t('90 days')}}</option>
            <option value=0>{{$t('Customize')}}</option>
          </select>

          <span style="margin-left:20px;">{{$t('Alert Filter')}}:</span>
          <select class="select-interval" v-model="alertTypeSelect" @change="procAlertTypeSelect">
            <option value="1">{{$t('PDM')}}</option>
            <option value="2">{{$t('Pump')}}</option>
            <option value="3">{{$t('CGM')}}</option>
          </select>
        </div>

        <div class="time-range" :class="{'zh2':!isEn}">
          <p>{{$t('From')}}</p>
          <div class="date">
            <span v-show="!customDaySpan">{{startDateText}}</span>
            <el-date-picker v-model="startDateValue" type="date"  :editable=false  :picker-options="pickerOptions" v-show="customDaySpan"
                            @change="startDateChange" :clearable=false  :placeholder="startDatePlaceholder"    format="dd-MM-yyyy">
            </el-date-picker>
          </div>
          <p>{{$t('To')}}</p>
          <div class="block">
            <el-date-picker v-model="endDateValue" type="date"  :editable=false  :picker-options="pickerOptions"
                            @change="endDateChange"     :clearable=false  :placeholder="endDatePlaceholder"  format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>

        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import format from '@/lib/format'
  /*
  2019-8-5 NOTES:
  value4 : 选择时间的起始时间， 是Date对象。是日期控件的模型数据。
  value3 : 选择时间的结束时间。
  st,et : 时间戳， 后端请求时用的参数。
  timeRange2: 显示的时间范围。
  * */
  export default {
    data() {
      return {
        uid:0, st:0,et:0,

        isEn:false,

        dialogSize:'small',
        haveData:true,

        typeChooseVisible:false,
        timeRangeSelect:1,
        timeRangeSelectActive:1,
        alertTypeSelect:1,
        alertTypeSelectActive:1,
        startDateText:'',
        startDateValue:new Date(),
        startDatePlaceholder:'',
        customDaySpan:false,
        endDateText:'',
        endDateValue:new Date(),
        endDatePlaceholder:'',
        timeRangeDisplay:'',

        alerts:[],


        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },
      }
    },

    methods: {

      open(){
        this.startDateValue=new Date(this.st*1000);   // 起始时间还原。
        //this.staTime=format.formatterDate4(this.st);
        this.startDateText=format.formatterDate4(this.st);
        this.endDateValue=new Date(this.et*1000);
        //this.endTime=format.formatterDate4(this.et);
        this.timeRangeSelect=this.timeRangeSelectActive;
        if (0==this.timeRangeSelect){
          this.customDaySpan=true;
        } else {
          this.customDaySpan=false;
        }

        this.typeChooseVisible=true;
      },

      cancel(){
        this.typeChooseVisible=false;
      },
      getAlertTypeText (alertTypeValue) {
        let alertTypeSelect=parseInt(alertTypeValue);
        let alertType='--';
        let AlertTypeTexts=[
          this.$t('PDM'),
          this.$t('Pump'),
          this.$t('CGM')
        ];
        if (alertTypeSelect==NaN || alertTypeSelect<1 || alertTypeSelect>3) {

        } else {
          alertType=AlertTypeTexts[alertTypeSelect-1];
        }
        //console.log('alertType:', alertTypeSelect, alertType, alertTypeValue);
        return alertType;
      },
      dateApply(){
        /*
        let st=this.startDateValue.getTime()/1000;
        let et=this.endDateValue.getTime()/1000;
        if (st>=et){
          this.$message.error("Date select wrong");
          return;
        }
        this.st=st;
        this.et=et;
        //
        let curDate=new Date();
        if ((curDate.getTime()-this.st*1000)>730*86400*1000){
          //this.$message.error('Can not select date of tow years ago!');
        }
        //
        //this.ckeckType();
        //this.getDate();
        this.timeRange2 = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et);
        this.staTime = format.formatterDate4(this.st);
        this.endTime = format.formatterDate4(this.et);
        this.value4=new Date(this.st*1000);
        this.value3=new Date(this.et*1000);
        //this.getData();
        this.typeChooseVisible=false;
        */
        let st=this.startDateValue.getTime()/1000;
        let et=this.endDateValue.getTime()/1000;
        if (st>=et){
          this.$message.error("Date select wrong");
          return;
        }
        let daySpan=(et-st)/86400+1;
        if (daySpan>90) {
          this.$message.error("Date select wrong");
          return;
        }
        this.st=st;
        this.et=et;

        this.timeRangeDisplay = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et)+', ' +
          this.getAlertTypeText(this.alertTypeSelect);
        this.timeRangeSelectActive=this.timeRangeSelect;
        this.alertTypeSelectActive=this.alertTypeSelect;
        this.typeChooseVisible=false;
        this.getAlertData();

        // 保存时间
        sessionStorage.setItem('st9', this.st);   // 保存时间的设置
        sessionStorage.setItem('et9', this.et);
        sessionStorage.setItem('timeRangeSelect9', this.timeRangeSelect);
        sessionStorage.setItem('alertTypeSelect', this.alertTypeSelect);
      },

      startDateChange(){

      },

      endDateChange(){
        let endDate=this.endDateValue;    // 选择的结束时间。
        let et=endDate.getTime()/1000;  // unix 时间戳
        let daySpan=0;
        if (1==this.timeRangeSelect) {
          daySpan=7;
        } else if (2==this.timeRangeSelect){
          daySpan=14;
        } else if (3==this.timeRangeSelet) {
          daySpan=30;
        } else if (4==this.timeRangeSelect) {
          daySpan=90;
        }
        if (daySpan) {
          let st=et-86400*(daySpan-1);  // 计算起始时间
          this.startDateValue=new Date(st*1000);  // 开始时间控件的变量
          this.startDateText = format.formatterDate4(st); // 开始时间的显示。
        }
      },

      procAlertTypeSelect(e){

      },
      procTimeRangeSelect(e){
        console.log('procTimeRangeSelect:', this.timeRangeSelect);
        let daySpan=0;
        if (1==this.timeRangeSelect){   // 7天
          daySpan=7;
        } else if (2==this.timeRangeSelect){  // 14天
          daySpan=14;
        } else if (3==this.timeRangeSelect || 4==this.timeRangeSelect){  // 30天
          daySpan=30;
          if (4==this.timeRangeSelect) {
            daySpan=90;
          }
        }
        //
        let et=this.endDateValue.getTime()/1000;   // 控件上的时间。

        console.log('daySpan:', daySpan);
        //this.dayNum=daySpan;
        if (daySpan) {
          let st=et-86400*(daySpan-1);
          //this.staTime=format.formatterDate4(st);
          this.startDateText=format.formatterDate4(st);
          this.startDateValue=new Date(st*1000);
        }
        if (0==this.timeRangeSelect) {
          //this.startDateDisable=false;
          this.customDaySpan=true;
        } else {
          //this.startDateDisable=true;
          this.customDaySpan=false;
        }
        //console.log('startDateDisable:', this.startDateDisable);
      },

      print(){
        sessionStorage.setItem('alert-data', JSON.stringify(
          {
            'alerts':this.alerts
          }
        ));

        window.open('/#/chart9-print','_blank');
      },
      procAlertData(alerts, ) {
        let isEn=this.isEn;
        let getAlertTypeTextFunc=this.getAlertTypeText;
        let that=this;
        alerts = alerts.filter(function(e, i){
          return e[1];
        });
        return alerts.map(function(e, i){
          let item=[];
          //item[0]=new Date(e[0]*1000);
          item[0]=(isEn)?format.formatterDate1(new Date(e[0]*1000)):format.formateDate(new Date(e[0]*1000));
          //item[1]=e[1];
          if (e[1]) {
            e[1] = ''+e[1];    // 转换成字符串
            let alert_sid='Alerts_'+e[1].replace(/ /g, '_');
            item[1] = that.$t(alert_sid);
          } else {
            let alertId=e[2];
            if (26==alertId) {
              item[1]='Auto Mode Exit';
            } else if (27==alertId) {
              item[1]='Auto Mode Max';
            }
            item[1]='';
          }
          item[2]=e[2];
          item[3]=getAlertTypeTextFunc(e[3]);
          return item;
        })
      },
      getAlertData() {
        //auth.getDashboard()
        //this.$http.get('/api/v2.1/')
        let params={
          st:this.st,
          et:this.et,
          alert_type:this.alertTypeSelect
        }
        this.$http.get('/api/v2.1/alerts/'+this.uid, {params:params}).then(function(res){
          //console.log('getAlertData:', res);
          if (0==res.data.error) {
            console.log('alerts:', res.data.alerts);
            let alerts=this.procAlertData(res.data.alerts);
            if (alerts.length>0) {
              this.alerts=alerts;
              this.haveData=true;
            } else {
              this.haveData=false;
              this.alerts=[];
            }
            //console.log('alerts:', alerts);
          }

        }, function(err){});
      }

    },

    mounted: function () {
      let width = window.innerWidth;
      //this.dialogSize =(width<1500)?'small':'tiny';
      this.isEn = (sessionStorage.getItem('language')!=='zh')?true:false;
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }

      if(!sessionStorage.getItem('st9')){
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time')
        console.log('chart_end_time:', chart_end_time);
        for (var d=0; d<3000; d++) {
          if (this.et > chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            this.et=cur_day/1000;
          } else {
            break;
          }
        }
        this.st = this.et-86400*6;

      } else {
        this.st=parseInt(sessionStorage.getItem('st9'));
        this.et=parseInt(sessionStorage.getItem('et9'));
        let timeRangeSelect=parseInt(sessionStorage.getItem('timeRangeSelect9'));
        let alertTypeSelect=parseInt(sessionStorage.getItem('alertTypeSelect'));
        console.log('alertTypeSelect:', timeRangeSelect, alertTypeSelect);
        this.timeRangeSelect=timeRangeSelect;
        this.timeRangeSelectActive=timeRangeSelect;
        this.alertTypeSelect=alertTypeSelect;
        this.alertTypeSelectActive=alertTypeSelect;
      }
      this.getAlertData();

      this.timeRangeDisplay = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.et)+', '+
        this.getAlertTypeText(this.alertTypeSelect);
      //this.staTime = format.formatterDate4(this.st);
      //this.endTime = format.formatterDate4(this.et);
      this.startDateText=format.formatterDate4(this.st);
      this.startDateValue=new Date(this.st*1000);
      this.endDateValue=new Date(this.et*1000);

      // 保存时间
      sessionStorage.setItem('st9', this.st);   // 保存时间的设置
      sessionStorage.setItem('et9', this.et);
      sessionStorage.setItem('timeRangeSelect9', this.timeRangeSelect);
      sessionStorage.setItem('alertTypeSelect', this.alertTypeSelect);

    },
  }
</script>

<style scoped>
  .chart-container {
    width: 100%;
    min-height:680px;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .main-header-right .set{
    margin-left: 0;
  }

  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }
  .bolCount p{
    height: 15px;
  }

  .countLabel td{
    border:none;
    * border: 1px solid #ccc;
  }


  /*选择日期范围时样式*/
  .time-range p{
    margin: 0 18px 18px;
    margin-top: 2px;
  }
  .time-range button{
    float: right;
    margin-right: 2.2%;
  }
  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .duration{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .duration span,
  .duration p {
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-left: 18px;
    margin-right: 15px;
    *width:80px;
  }

  .duration select{
    height: 30px;
    width: 120px;
    border-radius: 4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .dialog-body .time-range{
    margin-left: 22px;
    height:35px;
    line-height: 35px;
    margin-bottom: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 25px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:25%;
    height:40px;
    line-height: 40px;
    color:#282828;
    font-size: 16px;
    margin-right: 8%;
    margin-left: 14px;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }

  .statics-table tr{
    height:25px;
  }

  #est-a1c div {
    margin-bottom:5px;
  }

  .chart-container .row1 div{
    float:left;
  }

  /*表格*/
  .patient-table{
    width:100%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color: #282828;
    letter-spacing:-0.44px;
    text-align:center;
    word-break: break-all;
    word-wrap: break-word;
  }
  table{
    width:100%;
    border-collapse: collapse;
  }
  .patient-table .header{
    color:#005dac;
    height:70px;
    background:#cfdff0;
    font-size:18px;
  }

  tr{
    height: 60px;
    font-size:16px;
    letter-spacing:-0.39px;
    text-align:center;
  }

  .no-data {
    width: 96%;
    margin:0 auto;
    font-size:20px;
  }

  .x_event-detail {
    text-align: left;
  }
  .even{
    background:#ebeef1;
  }
</style>



// WEBPACK FOOTER //
// chart9.vue?148626e1